import { Component, OnInit, OnDestroy, Inject, Input } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'google-button',
  template: require('./google-button.component.pug'),
  styles: [require('./google-button.component.css').toString()],
})
export class GoogleButtonComponent implements OnInit, OnDestroy {
  @Input()
  url: string;

  csrf = '';

  // -------------------------------------------------------------------
  constructor(@Inject(DOCUMENT) private document: any) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.csrf = this.document.querySelector("meta[name='csrf-token']").content;
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {}
}
